import {
  Box,
  Button,
  DialogContent,
  Divider,
  Fade,
  Paper,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material'
import { IconX } from '@tabler/icons-react'
import { FC, useEffect, useState } from 'react'

export type ActionComponentProps = {
  onClose: () => void
}

type DialogContent = FC<ActionComponentProps>

export type SelectionPanelAction = {
  Component: DialogContent
  key: string
}

export const SelectionPanel = <T,>({
  rows,
  actions,
  onClose,
}: {
  actions: SelectionPanelAction[]
  rows: T[]
  onClose: () => void
}) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setOpen(rows.length !== 0)
  }, [rows.length])

  return (
    <Fade in={open} onExited={onClose}>
      <Stack
        direction="row"
        sx={{
          zIndex: (t) => t.zIndex.appBar,
          position: 'absolute',
          top: 0,
          left: 50,
          py: 1,
          px: 2,
          alignItems: 'center',
          gap: 2,
        }}
        component={Paper}
        elevation={4}
      >
        <Typography variant="caption" color="text.secondary" sx={{ span: { fontWeight: 'bold' } }}>
          Selected <span>{rows.length}</span>
        </Typography>

        <Stack
          direction="row"
          divider={<Divider orientation="vertical" flexItem />}
          sx={{
            gap: 1,
          }}
        >
          <Stack direction="row" spacing={1.5} useFlexGap sx={{ whiteSpace: 'nowrap' }}>
            {actions.map(({ Component, key }) => (
              <Box key={key} sx={{ '&:has(button:disabled:not(.loading))': { display: 'none' } }}>
                <Component onClose={() => setOpen(false)} />
              </Box>
            ))}
          </Stack>
          <Button
            onClick={() => setOpen(false)}
            endIcon={
              <SvgIcon>
                <IconX />
              </SvgIcon>
            }
            size="small"
          >
            Close
          </Button>
        </Stack>
      </Stack>
    </Fade>
  )
}
